module.exports = "//static.hsappstatic.net/react-codemirror/static-1.8089/theme/hubspot-canvas-dark.sass"